import { useMemo } from "react";
import Constants from "../../utils/Constants";

const RandomColors = Constants.DASHBOARD_COLOR_THEMES.Default;

function useThemeColors({
  theme,
  chartData,
}: {
  chartData?: any[];
  theme?: string[];
}) {
  const colors = useMemo<string[]>(() => {
    const finalTheme = [...(theme || RandomColors)];

    if (!Array.isArray(chartData) || !chartData?.length) return finalTheme;

    if (finalTheme.length >= chartData.length) return finalTheme;

    const numberOfColorsNeeded = chartData.length - finalTheme.length;

    const additionalColors = new Set<string>();

    while (additionalColors.size < numberOfColorsNeeded) {
      const newColor = "#" + Math.floor(Math.random() * 16777215).toString(16);

      if (!additionalColors.has(newColor)) {
        additionalColors.add(newColor);
      }
    }

    return [...finalTheme, ...additionalColors];
  }, [theme, chartData]);

  return { colors };
}

export default useThemeColors;
